import { CategoryDto } from "../category/category.dto";

export class LookupTypeDto extends CategoryDto {
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup-type/lookup-type.dto.ts